export default "__VITE_ASSET__jTfgzwqo__"